import { Fragment, type ReactElement } from "react";

type StepId = "upload" | "configure" | "repair" | "results";

const ORDER: StepId[] = ["upload", "configure", "repair", "results"];
const LABELS: Record<StepId, string> = {
  upload: "Upload",
  configure: "Configure",
  repair: "Repair",
  results: "Results",
};

export function Stepper({ active }: { active: StepId }): ReactElement {
  const ix = ORDER.indexOf(active);
  return (
    <div className="sr-stepper">
      {ORDER.map((id, i) => {
        const cls = i < ix ? "done" : i === ix ? "now" : "";
        return (
          <Fragment key={id}>
            <div className={`sr-step ${cls}`}>
              <span className="ord">{i < ix ? "✓" : String(i + 1).padStart(2, "0")}</span>
              <span>{LABELS[id]}</span>
            </div>
            {i < ORDER.length - 1 && <span className="ln" />}
          </Fragment>
        );
      })}
    </div>
  );
}

export const HINT_PRESETS: { id: string; label: string; desc: string }[] = [
  { id: "aggressive-void", label: "Aggressive on void risk", desc: "Replace every HIGH-void leg, even at lower odds." },
  { id: "keep-underdogs", label: "Keep my underdog picks", desc: "Never replace selections priced > 4.00." },
  {
    id: "maximise-prob",
    label: "Maximise landing probability",
    desc: "Prefer Safer-mode swaps over Sharp where they conflict.",
  },
  {
    id: "no-cross-fixture",
    label: "Never suggest cross-fixture",
    desc: "Only consider same-fixture alternatives. (Default)",
  },
  { id: "no-correct-score", label: "Avoid Correct Score", desc: "Replace any Correct Score leg regardless of edge." },
  { id: "dc-only", label: "Prefer Double Chance", desc: "When replacing, bias toward DC markets." },
];
